import { render, staticRenderFns } from "./SettingsWatermark.vue?vue&type=template&id=f626dc10&scoped=true&"
import script from "./SettingsWatermark.vue?vue&type=script&lang=js&"
export * from "./SettingsWatermark.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWatermark.vue?vue&type=style&index=0&id=f626dc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f626dc10",
  null
  
)

export default component.exports